import type Array from '@ember/array';
import Model, { attr, belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import type Company from 'garaje/models/company';
import type LocationModel from 'garaje/models/location';
import adapter from 'garaje/utils/decorators/adapter';
import serializer from 'garaje/utils/decorators/serializer';

@adapter('rooms-v2')
@serializer('rooms')
class RoomLocationConfig extends Model {
  @belongsTo('company', { async: true, inverse: null })
  declare company: AsyncBelongsTo<Company>;

  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel>;

  @attr('array') declare notificationEmails: Array<string>;
  @attr('boolean') declare globalAdminNotificationsEnabled: boolean;
  @attr('boolean') declare locationAdminNotificationsEnabled: boolean;
}

export default RoomLocationConfig;
